// src/infiniteQueryOptions.ts
function infiniteQueryOptions(options) {
  return options;
}
export {
  infiniteQueryOptions
};
//# sourceMappingURL=infiniteQueryOptions.js.map